import {useQuery} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {GetUserNames as GetUserNamesQuery} from 'nutshell-graphql-types';

import GET_USER_NAMES from '../queries/get-user-names.graphql';

export const useGetUserNames = (skip: boolean) => {
    const {
        data,
        loading: isLoading,
        error,
    } = useQuery<GetUserNamesQuery, Record<any, any>>(GET_USER_NAMES, {
        skip: skip,
    });

    if (skip) {
        return {
            users: null,
            isLoading: false,
            errorMessage: null,
        };
    }

    const users = data ? data.users : null;

    return {
        users: users,
        isLoading,
        // @ts-expect-error
        errorMessage: safelyGetGraphQLErrorMessage(error),
    };
};
